import * as React from 'react';
import { AlertProps } from './Alert.types';
import './styles/Alert.css';

export const Alert = ({
    status,
    children
}: AlertProps) => (
    <div className={`alert alert--${status}`}>
        {children}
    </div>
);